import AdminLayout from 'layouts/AdminLayout/AdminLayout';

import ErrorLayout from 'layouts/Error';
import React, { lazy } from 'react';

import { generatePath } from 'react-router';
import { renderRoutes } from 'react-router-config';
import { Redirect } from 'react-router-dom';
import WarehouseDocumentsForm from 'views/admin/Warehouse/WarehouseDocumentsForm';
import WarehouseForm from 'views/admin/Warehouse/WarehouseForm';
import V3SunsetInfoPage from './components/V3SunsetInfo';

// Views_Admin
import AdminAuthLayout from './layouts/AdminAuthLayout';
import AccountingDashboard from './views/admin/Accounting/Dashboard';
import AdminDashboard from './views/admin/dashboard';

const AdminOrders = lazy(() => import('views/admin/Orders/Orders'));
const AdminBatches = lazy(() => import('views/admin/Batches/BatchesSummary.jsx'));
const AdminSKU = lazy(() => import('views/admin/SKU/SKU'));
const AdminBundles = lazy(() => import('views/admin/Bundles/Bundles'));
const SummaryEdit = lazy(() => import('views/admin/SKU/SKUDetail/components/Summary/SummaryEdit.jsx'));
const AdminInvoices = lazy(() => import('views/admin/Accounting/Invoices/Invoice.jsx'));
const AdminSalesAgents = lazy(() => import('views/admin/Accounting/SalesAgents/salesAgents.jsx'));
const AdminShippingDetail = lazy(() => import('views/admin/Accounting/Shipping/ShippingDetail'));
const StandardEdit = lazy(() => import('views/admin/Accounting/Shipping/Standard/StandardEdit.js'));
const AdminInventory = lazy(() => import('views/admin/Warehouse/Inventory/Inventory.jsx'));
const AdminSettings = lazy(() => import('views/admin/Settings/SettingsDetail.jsx'));
const AdminSuppliers = lazy(() => import('views/admin/Warehouse/Suppliers/Suppliers.jsx'));
const AdminUsers = lazy(() => import('views/admin/Settings/Users/Users.js'));
const AdminOrganisations = lazy(() => import('views/admin/AdminOrganisations/AdminOrgDetail.jsx'));
const Duties = lazy(() => import('views/admin/Accounting/Other'));
const Warehouse = lazy(() => import('views/admin/Warehouse'));
const Support = lazy(() => import('views/admin/Support/Support'));
const PricingProposalForm = lazy(() => import('views/admin/Warehouse/PricingProposals/Form/index'));

export const reverseUserRoute = (name, id) => {
  const matchedRoute = userRoutes.filter((route) => route.name === name)[0];
  let finalPath;
  const uid = window.localStorage.getItem('organisation-uid');

  if (id) {
    finalPath = generatePath(matchedRoute?.path, { id, uid });
  } else {
    if (uid) {
      finalPath = generatePath(matchedRoute?.path, { uid });
    } else {
      finalPath = matchedRoute?.path;
    }
  }

  return finalPath;
};

const Root = ({ route }) => <>{renderRoutes(route.routes)}</>;

const adminAuthRoutes = [
  {
    path: '/admin/auth/login',
    exact: true,
    component: lazy(() => import('layouts/AdminAuthLayout')),
    //component: AuthLayout
  },
  {
    component: () => <Redirect to='/errors/error-404' />,
  },
];


export const userRoutes = [];

// Friendly reminder that to edit the links in the navbar, you should look in components/NavBar/navigationConfig.js
// This file is only for the physical routing of pages in the virtual dom
export const routes = [
  {
    component: Root,
    routes: [
      {
        path: '/',
        exact: true,
        component: () => <V3SunsetInfoPage />,
      },
      {
        path: '/user/:any?',
        component: () => <Redirect to={'/'} />,
      },
      {
        path: '/errors',
        component: ErrorLayout,
        routes: [
          {
            path: '/errors/error-401',
            exact: true,
            component: lazy(() => import('views/Error401')),
          },
          {
            path: '/errors/error-404',
            exact: true,
            component: lazy(() => import('views/Error404')),
          },
          {
            path: '/errors/error-500',
            exact: true,
            component: lazy(() => import('views/Error500')),
          },
          {
            component: () => <Redirect to='/errors/error-404' />,
          },
        ],
      },

      {
        path: '/admin/auth',
        component: AdminAuthLayout,
        routes: adminAuthRoutes,
      },

      {
        path: '/admin',
        component: AdminLayout,
        routes: [
          {
            path: '/admin',
            exact: true,
            component: () => <Redirect to='/admin/manage/orders' />,
          },
          {
            path: '/admin/',
            exact: true,
            component: () => <Redirect to='/admin/manage/orders' />,
          },
          // Support Routes moved here
          {
            path: '/admin/support/investigation/:id',
            component: Support,
          },
          {
            path: '/admin/support/investigation',
            component: Support,
          },
          {
            path: '/admin/support/unassigned/:id',
            component: Support,
          },
          {
            path: '/admin/support/unassigned',
            component: Support,
          },
          {
            path: '/admin/support/create-enquiry',
            component: Support,
          },
          {
            path: '/admin/support/archive/:id',
            component: Support,
          },
          {
            path: '/admin/support/archive',
            component: Support,
          },
          {
            path: '/admin/support/bookings',
            component: Support,
          },
          {
            path: '/admin/support/tags',
            component: Support,
          },
          {
            path: '/admin/support/tickets',
            component: Support,
          },
          {
            path: '/admin/dashboard',
            exact: true,
            component: AdminDashboard,
          },
          {
            path: '/admin/manage/orders',
            exact: true,
            component: AdminOrders,
          },

          {
            path: '/admin/manage/orders/:id/shipment/parcel',
            exact: true,
            component: AdminOrders,
          },

          {
            // name: 'Orders:detail',
            path: '/admin/manage/orders/:id',
            // exact: true,
            component: AdminOrders,
          },

          // Admin/Batches
          {
            path: '/admin/manage/batches',
            exact: true,
            component: AdminBatches,
          },
          {
            path: '/admin/manage/batches/:id/choose-trolley',
            exact: true,
            component: AdminBatches,
          },
          {
            path: '/admin/manage/batches/:id',
            exact: true,
            component: AdminBatches,
          },
          {
            path: `/admin/manage/batches/:id/detail`,
            exact: true,
            component: AdminBatches,
          },

          // Admin/Sku
          {
            path: '/admin/products/sku',
            //exact: true,
            component: AdminSKU,
          },

          {
            path: '/admin/bundles',
            component: AdminBundles,
          },

          {
            path: '/admin/products/sku/detail',
            //exact: true,
            component: AdminSKU,
          },
          {
            path:
              '/admin/products/sku/SKUDetail/components/Summary/SummaryEdit',
            exact: false,
            component: SummaryEdit,
          },
          // Admin/Accounting
          // Invoice
          {
            path: '/admin/accounting/invoices/:invoice_id/details',
            exact: true,
            component: AdminInvoices,
          },
          {
            path: '/admin/accounting/invoices/drafts/:invoice_id/details',
            exact: true,
            component: AdminInvoices,
          },
          {
            path: '/admin/accounting/invoices',
            //exact: true,
            component: AdminInvoices,
          },

          // Admin/Accounting
          // SalesAgents

          {
            path: '/admin/accounting/sales-agents/:sales_agent_id/:tab',
            exact: true,
            component: AdminSalesAgents,
          },
          {
            path: '/admin/accounting/sales-agents',
            //exact: true,
            component: AdminSalesAgents,
          },
          {
            path: '/admin/accounting/sales-agents/add',
            exact: true,
            component: AdminSalesAgents,
          },

          //Other - Duties
          {
            path: '/admin/accounting/others',
            component: Duties,
          },

          {
            path: '/admin/accounting/:tab',
            exact: true,
            component: AccountingDashboard,
          },

          {
            path: '/admin/warehouses/add',
            component: WarehouseForm,
          },
          {
            path: '/admin/warehouses/:id/summary/edit',
            component: WarehouseForm,
          },
          {
            path: '/admin/warehouses/:id/documents/edit',
            component: WarehouseDocumentsForm,
          },
          {
            path: '/admin/warehouses/:wid/shipping/:id/:tab',
            component: AdminShippingDetail,
          },
          {
            path: '/admin/warehouses/:wid/shipping/:id/:tab/add',
            component: AdminShippingDetail,
          },
          {
            path: '/admin/warehouses/:wid/shipping/:id/:tab/:subId/edit',
            component: AdminShippingDetail,
          },
          {
            path: '/admin/warehouses/:wid/shipping/standard/Edit',
            exact: false,
            component: StandardEdit,
          },

          {
            path: '/admin/warehouses/:wid/proposals/:id/edit',
            exact: true,
            component: PricingProposalForm,
          },
          {
            path: '/admin/warehouses/:wid/proposals/add',
            exact: true,
            component: PricingProposalForm,
          },
          // Inventory
          {
            path: '/admin/warehouses/inventory',
            exact: true,
            component: AdminInventory,
          },
          {
            path: '/admin/warehouses/inventory/add/:type',
            exact: true,
            component: AdminInventory,
          },
          {
            path: '/admin/warehouses/inventory/:id/detail/:tab',
            //exact: true,
            component: AdminInventory,
          },
          {
            path: '/admin/warehouses/:tab',
            component: Warehouse,
          },

          //Supplier
          {
            path: '/admin/warehouses/suppliers',
            exact: true,
            component: AdminSuppliers,
          },
          {
            path: '/admin/warehouses/suppliers/add',
            exact: true,
            component: AdminSuppliers,
          },
          {
            path: '/admin/warehouses/suppliers/:id/edit',
            exact: true,
            component: AdminSuppliers,
          },


          /*{
            path: '/admin/warehouses/zones',
            component: Zones
          },*/

          // Settings
          {
            path: '/admin/settings',
            exact: true,
            component: AdminSettings,
          },
          {
            path: '/admin/settings/:tab',
            exact: false,
            component: AdminSettings,
          },

          {
            path: '/admin/settings/users',
            component: AdminUsers,
          },

          {
            path: '/admin/organisations/:tab',
            component: AdminOrganisations,
          },


          {
            path: '/admin/errors/error-404',
            exact: true,
            component: lazy(() => import('views/Error404')),
          },
          {
            component: () => <Redirect to='/admin/errors/error-404' />,
          },
        ],
      },


      {
        path: '/undefined',
        component: ErrorLayout,
        routes: [
          {
            path: '/undefined/error',
            exact: true,
            component: lazy(() => import('views/Error404')),
          },
        ],
      },

      {
        component: () => <Redirect to='/' />,
      },
    ],
  },
];
